(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-show-more"] && !Shopify.designMode) return;
  try {
    class FaqShowMore extends HTMLElement {
    connectedCallback() {
      this.querySelector('button')?.addEventListener('click', this.#expand);
    }

    #expand = () => {
      const rows = Array.from(this.closest('.shopify-section')?.querySelectorAll('accordion-custom') ?? []);
      const firstHidden = rows.find((row) => row.checkVisibility && !row.checkVisibility());
      this.dataset.expanded = 'true';
      this.querySelector('button')?.setAttribute('aria-expanded', 'true');
      // Keyboard users land on the first question that just appeared.
      firstHidden?.querySelector('summary')?.focus();
    };
  }

  if (!customElements.get('faq-show-more')) customElements.define('faq-show-more', FaqShowMore);
  } catch(e) { console.error(e); }
})();

})();
